import {
  CButton,
  spacing,
  VNode,
  VNodeBtnProps,
  VNodeData,
} from '@/js/lib/helper-classes'
import uuid from 'uuid/v4'

export class VNodeCCardBtnProps extends VNodeBtnProps {
  form = false
  isBlock = true
  isCardButton = true
  vnodeId = uuid()
  enable = true
}

class CCardButton extends CButton {
  data = new VNodeData({
    props: new VNodeCCardBtnProps(),
  })
}


export class CCard extends VNode {
  tag = 'c-card'
  data = new VNodeData({
    props: {
      ...spacing({
        margin: {
          vertical: 'my-0',
          horizontal: 'mx-0',
        },
        padding: {
          vertical: 'py-1',
          horizontal: 'px-1',
        },
      }),
      background: {
        image: '',
        size: 'cover',
        repeat: 'no-repeat',
        y: 0,
        active: 'image',
      },
      border: '',
      borderRadius: 0,
      shadow: '',
      cardItems: [new CCardItem(), new CCardItem(), new CCardItem()],
      alignment: {
        column: false,
        verticalAlignment: 'start',
        horizontalAlignment: 'start',
      },
      layout: 'narrow',
      layoutGap: 10,
      layoutWrap: 'unset',
      layoutSpacing: 'space-evenly',
      layoutView: 'list',
      version: 2,
      itemStyles: {
        borderStyle: '',
        borderPosition: {
          all: 'set',
          lft: '',
          ryt: '',
          btm: '',
          top: '',
        },
        borderColor: '',
        borderRadius: 0,
        shadow: '',
        borderWidth: 0,
      },
    },
  })
  children = []
}

class CCIcon {
  set = 'material-icon'
  selector = 'star_half'
  size = 2
  themeColorId = ''
  themeColorAlpha = 1
  alignment = 'center'
  enable = true
}

export class CCardItem {
  template = {
    gap: 10,
    icon: new CCIcon(),
    headline: {
      text: '<h5 class="font-style-lead"><strong>Feature element</strong></h5>',
      enable: true,
    },
    subHeadline: {
      text: '<p class="text-lead">This is awesome element has more variants and fully customizable properties.</p>',
      enable: true,
    },
    enableBackground: true,
    button: new CCardButton(),
    useIconAsImage: false,
  }

  background = {
    image: '',
    size: 'cover',
    repeat: 'no-repeat',
    y: 0,
    active: 'image',
  }
  borderPosition = {
    all: 'set',
    lft: '',
    ryt: '',
    btm: '',
    top: '',
  }
  border = ''
  borderRadius = null
  shadow = ''
  class = {}
  style = {}
  vnodeId = uuid()
  domProps = {}
  attrs = {}

  cardWidth = 18

  constructor() {
    let _spacing = spacing({
      margin: {
        vertical: 'my-0',
        horizontal: 'mx-0',
      },
      padding: {
        vertical: 'py-1',
        horizontal: 'px-1',
      },
    })
    this.margin = _spacing.margin
    this.padding = _spacing.padding
  }
}


export class CCardElementContainer extends VNode {
  tag = 'c-card-element-container'
  data = new VNodeData({
    props: {
      ...spacing({
        margin: {
          vertical: 'my-0',
          horizontal: 'mx-0',
        },
        padding: {
          vertical: 'py-1',
          horizontal: 'px-1',
        },
      }),
      background: {
        image: '',
        size: 'cover',
        repeat: 'no-repeat',
        y: 0,
        active: 'image',
      },
      border: '',
      borderRadius: 0,
      shadow: '',
      alignment: {
        column: false,
        verticalAlignment: 'start',
        horizontalAlignment: 'start',
      },
      layout: 'narrow',
      layoutGap: 10,
      layoutWrap: 'unset',
      layoutSpacing: 'space-evenly',
      layoutView: 'card',
      itemStyles: {
        borderStyle: '',
        borderPosition: {
          all: 'set',
          lft: '',
          ryt: '',
          btm: '',
          top: '',
        },
        borderColor: '',
        borderRadius: 0,
        shadow: '',
        borderWidth: 0,
      },
    },
  })
  children = [new CCardElement({ cardWidth: 18 }), new CCardElement({ cardWidth: 18 }), new CCardElement({ cardWidth: 18 })]
}